import Phaser from "phaser"
import { recordPlayer } from "../../services/Request"

export default class CountDown extends Phaser.Scene {

    preload() {

        this.load.audio('click-sound', require('../../assets/sounds/click.mp3'));

        this.load.image("counter-background", require('./assets/background.webp'));
        this.load.image("counter-label", require('./assets/GameStarting.png'));
        this.load.image("counter-timer-03", require('./assets/3.png'));
        this.load.image("counter-timer-02", require('./assets/2.png'));
        this.load.image("counter-timer-01", require('./assets/1.png'));
        this.load.image("counter-timer-start", require('./assets/GameStart.png'));

    }

    create() {
        recordPlayer();
        this.initialTime = 4;
        this.clickSound = this.sound.add('click-sound', { volume: 0.5, loop: false });
        this.timedEvent = this.time.addEvent({ delay: 1000, callback: this.CountDown, callbackScope: this, loop: true });
        this.timeText = this.add.text(400, 600, this.initialTime, { fontFamily: 'Rockridge', fontSize: 300, color: '#F05B45' })
        this.soundConfig();
        this.canvasWidth = this.game.config.width;
        this.canvasHeight = this.game.config.height;

        this.add.image(0, 0, "counter-background").setOrigin(0, 0);
        this.add.image(this.canvasWidth / 2, 539, "counter-label");

        

        this.counter_03 = this.add.image(this.canvasWidth / 2, 911, "counter-timer-03").setVisible(false);
        this.counter_02 = this.add.image(this.canvasWidth / 2, 911, "counter-timer-02").setVisible(false);
        this.counter_01 = this.add.image(this.canvasWidth / 2, 911, "counter-timer-01").setVisible(false);
        this.counter_start = this.add.image(this.canvasWidth / 2, 911, "counter-timer-start").setVisible(false);
        this.counters = [
            this.counter_start,
            this.counter_01,
            this.counter_02,
            this.counter_03,
        ];

    }

    CountDown() {
        this.initialTime--;

        this.counters.forEach((counter, index) => {
            counter.setVisible(false);
        });
        if (this.counters[this.initialTime]) {
            this.counters[this.initialTime].setVisible(true);
        }


        if (this.initialTime <= -1) {
            this.scene.start('GameStage');
        }
        this.timeText.setText(this.initialTime);
        this.clickSound.play();

    }
    soundConfig(){
        this.clickSound.mute = !this.game.config.soundSetting;
    }
    update() {

    }

}